import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Track when auth was last confirmed so we can ignore transient 401s
// that fire during the initial page-load race (before cookies hydrate).
let authConfirmedAt = 0;
export function markAuthConfirmed() {
  authConfirmedAt = Date.now();
}

// Global response interceptor:
//   - Silently swallow 401s from /auth/me & /auth/refresh (probes)
//   - For other 401s, broadcast a session-expired event ONLY if auth
//     was confirmed at least 1.5s ago (avoids first-load race conditions)
api.interceptors.response.use(
  (res) => res,
  (error) => {
    const status = error?.response?.status;
    const url = error?.config?.url || "";
    if (status === 401) {
      if (url.includes("/auth/me") || url.includes("/auth/refresh")) {
        return Promise.reject({ __silent: true, status });
      }
      const elapsed = Date.now() - authConfirmedAt;
      if (authConfirmedAt && elapsed > 1500) {
        window.dispatchEvent(new CustomEvent("auth:session-expired"));
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
